/**
 * Embedded Auth Provider
 *
 * Provides UnifiedAuthContext using Bitrix24 session authentication.
 * Use this provider for embedded routes (/embedded/*).
 */
import { ReactNode, useMemo } from 'react';
import { useEmbeddedOrg } from '@/contexts/EmbeddedOrgContext';
import { useEmbeddedApiClient } from '@/hooks/useEmbeddedApiClient';
import { UnifiedAuthProvider } from './UnifiedAuthContext';

export function EmbeddedAuthProvider({ children }: { children: ReactNode }) {
  const { orgId, role, isLoading, error, weekStartsOn } = useEmbeddedOrg();
  const { apiClient } = useEmbeddedApiClient();

  const value = useMemo(
    () => ({
      apiClient,
      orgId,
      role,
      isLoading,
      isOrgSwitching: false,
      error,
      weekStartsOn,
    }),
    [apiClient, orgId, role, isLoading, error, weekStartsOn]
  );

  return <UnifiedAuthProvider value={value}>{children}</UnifiedAuthProvider>;
}
